module.exports = __webpack_public_path__ + "static/media/next-forward.6b2feae2.svg";